module.exports = __webpack_public_path__ + "img/04 KIT.28d4294d.png";